var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.857 0H1.139A1.148 1.148 0 0 0 0 1.15v13.7A1.148 1.148 0 0 0 1.139 16h13.718A1.151 1.151 0 0 0 16 14.85V1.15A1.151 1.151 0 0 0 14.857 0ZM4.836 13.714H2.464V6.079h2.375v7.636ZM3.65 5.036a1.375 1.375 0 1 1 1.375-1.375A1.376 1.376 0 0 1 3.65 5.036Zm10.075 8.679h-2.371V10c0-.886-.018-2.025-1.232-2.025-1.236 0-1.425.964-1.425 1.961v3.779H6.325V6.079H8.6v1.042h.032a2.5 2.5 0 0 1 2.246-1.232c2.4 0 2.846 1.582 2.846 3.639Z"
  })));
};

export default SvgLinkedin;